import {
  GRETA_AI_CHAT_FINANCE_NOT_BOUGHT_TEXT_KEY,
  GRETA_AI_CHAT_SOURCE_TEXT_KEYS,
} from '../GretaAIChat.constants'
import { getIsGretaAIChatFinanceSource } from '../GretaAIChat.utils.source'

import { GRETA_AI_CHAT_SOURCE_SWITCH_KEYS } from './GretaAIChatSourceSwitch.constants'

function getGretaAIChatSourceSwitchOffOptionTooltipKey({
  isFinanceNotBought,
  option,
  source,
}) {
  return isFinanceNotBought && getIsGretaAIChatFinanceSource(option)
    ? GRETA_AI_CHAT_FINANCE_NOT_BOUGHT_TEXT_KEY
    : GRETA_AI_CHAT_SOURCE_TEXT_KEYS[source].pinnedKey
}

export function getIsGretaAIChatSourceSwitchKey(key) {
  return GRETA_AI_CHAT_SOURCE_SWITCH_KEYS.includes(key)
}

export function getGretaAIChatSourceSwitchPinnedTooltipKey({
  isFinanceNotBought,
  isPinned,
  option,
  source,
}) {
  return isPinned && option !== source
    ? getGretaAIChatSourceSwitchOffOptionTooltipKey({
        isFinanceNotBought,
        option,
        source,
      })
    : null
}
